import React from 'react';
import { FOOTER_LINKS } from '../../utils/constants';

const SOCIALS = ['𝕏', '⬡', '◈', '⊞'];

const Footer: React.FC = () => (
  <footer
    style={{
      borderTop: '1px solid var(--border)',
      background: 'var(--surface)',
      padding: 'clamp(20px, 4vw, 32px) clamp(16px, 4vw, 32px) 20px',
      marginLeft: 260,
    }}
    className="footer-el"
  >
    {/* Top row */}
    <div
      style={{
        display: 'flex', flexWrap: 'wrap',
        gap: 28, justifyContent: 'space-between',
        alignItems: 'flex-start', marginBottom: 24,
      }}
    >
      {/* Brand */}
      <div style={{ maxWidth: 240 }}>
        <div
          style={{
            fontWeight: 800, fontSize: '1rem', marginBottom: 8,
            background: 'linear-gradient(90deg, var(--accent), var(--accent2))',
            WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
          }}
        >
          FIN Contra
        </div>
        <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', lineHeight: 1.65 }}>
          A professional React Native development environment for building, converting, and deploying Android APKs — all in the browser.
        </p>
      </div>

      {/* Link columns */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 36 }}>
        {Object.entries(FOOTER_LINKS).map(([col, links]) => (
          <div key={col}>
            <div
              style={{
                fontSize: '0.68rem', fontWeight: 700,
                letterSpacing: '0.1em', color: 'var(--text-dim)',
                textTransform: 'uppercase', marginBottom: 10,
              }}
            >
              {col}
            </div>
            {links.map((link) => (
              <a
                key={link}
                href="#"
                style={{
                  display: 'block', fontSize: '0.8rem',
                  color: 'var(--text-muted)', marginBottom: 6,
                  transition: 'color var(--transition-fast)',
                  textDecoration: 'none',
                }}
                onMouseEnter={(e) => ((e.target as HTMLElement).style.color = 'var(--accent)')}
                onMouseLeave={(e) => ((e.target as HTMLElement).style.color = 'var(--text-muted)')}
              >
                {link}
              </a>
            ))}
          </div>
        ))}
      </div>
    </div>

    {/* Bottom row */}
    <div
      style={{
        display: 'flex', justifyContent: 'space-between',
        alignItems: 'center', flexWrap: 'wrap', gap: 8,
        paddingTop: 16, borderTop: '1px solid var(--border)',
      }}
    >
      <span style={{ fontSize: '0.72rem', color: 'var(--text-muted)' }}>
        © 2026 FIN Contra — Built with React & TypeScript
      </span>

      <div style={{ display: 'flex', gap: 8 }}>
        {SOCIALS.map((s) => (
          <button
            key={s}
            style={{
              width: 30, height: 30, borderRadius: 'var(--radius-sm)',
              background: 'var(--surface2)', border: '1px solid var(--border)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 12, cursor: 'pointer', color: 'var(--text-muted)',
              transition: 'all var(--transition-fast)',
            }}
            onMouseEnter={(e) => {
              const el = e.currentTarget;
              el.style.borderColor = 'var(--accent)';
              el.style.color = 'var(--accent)';
              el.style.background = 'var(--accent-dim)';
            }}
            onMouseLeave={(e) => {
              const el = e.currentTarget;
              el.style.borderColor = 'var(--border)';
              el.style.color = 'var(--text-muted)';
              el.style.background = 'var(--surface2)';
            }}
          >
            {s}
          </button>
        ))}
      </div>
    </div>

    <style>{`
      @media (max-width: 900px) {
        .footer-el { margin-left: 0 !important; }
      }
    `}</style>
  </footer>
);

export default Footer;
